import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="15" height="20"><g stroke="#4E4E4E" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M5.064 5.452h-4v13h9V14.85"/><path d="M7.454 1.452h-2.39v13h9v-13z"/></g></svg>`;

export { symbol as default };
